module.exports = __webpack_public_path__ + "img/logo_hcc.5cc13a56.png";